import React from "react";
import { motion } from "framer-motion";
import step1 from "../Assets/steps/step1.png";
import step2 from "../Assets/steps/step2.png";
import step3 from "../Assets/steps/step3.png";
import step4 from "../Assets/steps/step4.png";

const steps = [
  { image: step1, number: 1, text: "Start the Bot" },
  { image: step2, number: 2, text: "Connect Your Wallet (auto-generated on first use)" },
  { image: step3, number: 3, text: "Enter a Token Address to buy, sell, or set a limit order" },
  { image: step4, number: 4, text: "Track or Withdraw, all inside Telegram" },
];

const HowItWorks = () => {
  return (
    <section id="how-it-works"  className="w-full px-4 sm:px-6 md:px-8 py-36 sm:py-24 md:py-48 lg:py-64 text-white">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-center mb-12">
          How It Works
        </h2>

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          {steps.map((step, index) => (
            <motion.div
              key={step.number}
              className={`flex flex-col items-center text-center space-y-3 sm:space-y-4 ${
                step.number === 1 ? "lg:mt-72" :
                step.number === 2 ? "lg:mt-48" :
                step.number === 3 ? "lg:mt-24" :
                "lg:mt-0"
              }`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
            >
              <img src={step.image} alt={`Step ${step.number}`} className="w-20 h-20 object-cover mb-4" />
              <div className="flex items-center space-x-4">
                <span className="text-2xl sm:text-3xl md:text-4xl font-bold">{step.number}</span>
                <p className="text-white text-left text-sm sm:text-base md:text-lg">{step.text}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
        <h3 className="text-center text-lg sm:text-xl md:text-3xl lg:text-6xl text-white/50 mt-12 font-semibold">
          Fast. Simple. On-chain.
        </h3>
      </div>
    </section>
  );
};

export default HowItWorks;
